let parentUrl = "";

// Setter
export const setParentUrl = (url) => {
  parentUrl = url;
};

// Getter
export const getParentUrl = () => parentUrl;